import { render, staticRenderFns } from "./delete-library.vue?vue&type=template&id=cef1461a&scoped=true&"
import script from "./delete-library.vue?vue&type=script&lang=js&"
export * from "./delete-library.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cef1461a",
  null
  
)

export default component.exports